import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogNotificationsChannelComponent } from './change-log-notifications-channel.component';
import { NorificationChannelByIdPipe } from './norification-channel-by-id.pipe';
import { NotificationChannelsService } from 'ag-common-svc/lib/components/administration/notifications-hub/notifications-channels/notifications-channels.service';

@NgModule({
  declarations: [ChangeLogNotificationsChannelComponent, NorificationChannelByIdPipe],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogNotificationsChannelComponent],
  providers: [NotificationChannelsService],
})
export class ChangeLogNotificationsChannelModule {}
